import Checkbox from "./Checkbox";
export default Checkbox;
export type { CheckboxProps } from "./Checkbox";

